import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { ChecklistTemplate } from '@portal-core/checklist-templates/models/checklist-template.model';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';

@CollectionStateSelectors({
  stateType: ChecklistTemplatesState
})
@State<ChecklistTemplatesState>({
  name: ChecklistTemplatesState.source
})
@Service({ autoProvided: false })
export class ChecklistTemplatesState extends CollectionStateBase {
  static override source = 'ChecklistTemplates';
  getSource(): string {
    return ChecklistTemplatesState.source;
  }
}

@Service()
export class ChecklistTemplatesDataService extends CollectionDataServiceBase<ChecklistTemplate> {
  protected readonly stateType = ChecklistTemplatesState;
}
